import { configureStore } from "@reduxjs/toolkit";
import globalReducer from "../utils/globalSlice";
import carousalReducer from "../components/Carousal/carousalSlice";
import { apis } from "./api/Apis";
import { setupListeners } from "@reduxjs/toolkit/dist/query";
import carFilterReducer from "../components/CarFilter/CarFilterSlice";
export const store = configureStore({
  reducer: {
    global: globalReducer,
    carousal: carousalReducer,
    [apis.reducerPath]: apis.reducer, //reducr for rtk query, handles cache
    carFilter: carFilterReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apis.middleware),
});
setupListeners(store.dispatch);
